import { get, post, put } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";

export interface ItemListadoServiciosGuarderia {
  id: string;
  nombre: string;
  descripcion?: string;
  dias: number;
  precioTotal: number;
}

export const listarServiciosGuarderia = async (): Promise<
  ItemListadoServiciosGuarderia[] | undefined
> => {
  return get<ItemListadoServiciosGuarderia[]>(`servicios/guarderia`);
};

export interface NuevoServicioGuarderia {
  nombre: string;
  descripcion?: string;
  dias: number;
  precioTotal: number;
  horaSalida?: number;
}

export const crearServicioGuarderia = async (
  nuevoServicioGuarderia: NuevoServicioGuarderia
): Promise<undefined> => {
  return post<NuevoServicioGuarderia, any | undefined>(
    "servicios/guarderia",
    nuevoServicioGuarderia
  );
};

export interface ServicioGuarderia {
  id: string;
  nombre: string;
  descripcion?: string;
  dias: number;
  precioTotal: number;
  horaSalida?: number;
}

export const QUERY_KEY_BUSCAR_SERVICIO_GUARDERIA = "buscar_servicio_guarderia";

export const useBuscarServicioGuarderia = (id?: string) => {
  if (!id) {
    throw Error("Id de servicio no definido");
  }
  return useQuery(
    [QUERY_KEY_BUSCAR_SERVICIO_GUARDERIA],
    async () => await buscarServicioGuarderia(id)
  );
};

export const buscarServicioGuarderia = async (
  id: string
): Promise<ServicioGuarderia | undefined> => {
  return get<ServicioGuarderia>(`servicios/guarderia/${id}`);
};

export const reemplazarServicioGuarderia = async (
  servicioGuarderia: ServicioGuarderia
) => {
  return put<ServicioGuarderia, undefined>(
    `servicios/guarderia`,
    servicioGuarderia
  );
};

export const QUERY_KEY_LISTAR_PLANES_GUARDERIA =
  "QUERY_KEY_LISTAR_PLANES_GUARDERIA";

export const useListarServiciosGuarderiaPorTipo = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_PLANES_GUARDERIA],
    async () => await listarServiciosGuarderiaPorTipo()
  );
};

export interface ServiciosGuarderiaPorTipo {
  tarifaIndividual?: ItemListadoServiciosGuarderia;
  planes: ItemListadoServiciosGuarderia[];
}

export const listarServiciosGuarderiaPorTipo = async () => {
  return get<ServiciosGuarderiaPorTipo>(`servicios/guarderia/por_tipo`);
};
